/*
 * ---------------------------------------------------------------------
 * Stageview Action Types
 * ---------------------------------------------------------------------
 */
export const SET_EXHIBIT_LIST = "SET_EXHIBIT_LIST";
export const SET_ACTIVE_EXHIBIT = "SET_ACTIVE_EXHIBIT";
